package com.flowyride.feature.navigation.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.BoxWithConstraintsScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.layout.boundsInRoot
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInParent
import androidx.compose.ui.layout.positionInRoot
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigationevent.NavigationEventInfo
import androidx.navigationevent.compose.NavigationBackHandler
import androidx.navigationevent.compose.rememberNavigationEventState
import com.flowyride.core.device.NavigationWindowEffect
import com.flowyride.core.device.StatusBarIconsEffect
import com.flowyride.core.device.formatClockTime
import com.flowyride.core.device.rememberNavigationPermissions
import com.flowyride.core.domain.model.Maneuver
import com.flowyride.core.domain.model.ManeuverType
import com.flowyride.core.domain.navigation.NavigationPhase
import com.flowyride.core.domain.navigation.NavigationSnapshot
import com.flowyride.core.map.NavigationMap
import com.flowyride.feature.navigation.NavigationAction
import com.flowyride.feature.navigation.NavigationUiEvent
import com.flowyride.feature.navigation.NavigationUiState
import com.flowyride.feature.navigation.NavigationViewModel
import com.flowyride.feature.navigation.RideSummary
import com.flowyride.feature.navigation.resources.Res
import com.flowyride.feature.navigation.resources.arrival_time
import com.flowyride.feature.navigation.resources.arrived_close
import com.flowyride.feature.navigation.resources.arrived_summary
import com.flowyride.feature.navigation.resources.arrived_title
import com.flowyride.feature.navigation.resources.camera_ahead
import com.flowyride.feature.navigation.resources.camera_ahead_limit
import com.flowyride.feature.navigation.resources.cancel
import com.flowyride.feature.navigation.resources.location_denied
import com.flowyride.feature.navigation.resources.location_retry
import com.flowyride.feature.navigation.resources.maneuver_arrive
import com.flowyride.feature.navigation.resources.maneuver_arrive_rejoin
import com.flowyride.feature.navigation.resources.maneuver_arrive_start
import com.flowyride.feature.navigation.resources.maneuver_bear_left
import com.flowyride.feature.navigation.resources.maneuver_bear_right
import com.flowyride.feature.navigation.resources.maneuver_exit_left
import com.flowyride.feature.navigation.resources.maneuver_exit_right
import com.flowyride.feature.navigation.resources.maneuver_ferry
import com.flowyride.feature.navigation.resources.maneuver_follow_route
import com.flowyride.feature.navigation.resources.maneuver_keep_left
import com.flowyride.feature.navigation.resources.maneuver_keep_right
import com.flowyride.feature.navigation.resources.maneuver_merge
import com.flowyride.feature.navigation.resources.maneuver_roundabout_any
import com.flowyride.feature.navigation.resources.maneuver_roundabout_plain
import com.flowyride.feature.navigation.resources.maneuver_sharp_left
import com.flowyride.feature.navigation.resources.maneuver_sharp_right
import com.flowyride.feature.navigation.resources.maneuver_straight
import com.flowyride.feature.navigation.resources.maneuver_turn_left
import com.flowyride.feature.navigation.resources.maneuver_turn_right
import com.flowyride.feature.navigation.resources.maneuver_u_turn
import com.flowyride.feature.navigation.resources.maneuver_waypoint
import com.flowyride.feature.navigation.resources.off_route
import com.flowyride.feature.navigation.resources.north_up
import com.flowyride.feature.navigation.resources.overview
import com.flowyride.feature.navigation.resources.recenter
import com.flowyride.feature.navigation.resources.resume
import com.flowyride.feature.navigation.resources.off_route_no_network
import com.flowyride.feature.navigation.resources.off_route_searching
import com.flowyride.feature.navigation.resources.preparing_guidance
import com.flowyride.feature.navigation.resources.rejoining
import com.flowyride.feature.navigation.resources.remaining
import com.flowyride.feature.navigation.resources.simulation
import com.flowyride.feature.navigation.resources.speed_unit
import com.flowyride.feature.navigation.resources.stop
import com.flowyride.feature.navigation.resources.stop_confirm
import com.flowyride.feature.navigation.resources.stop_confirm_title
import com.flowyride.feature.navigation.resources.then
import com.flowyride.feature.navigation.resources.to_start
import com.flowyride.feature.navigation.resources.waiting_gps
import com.flowyride.feature.navigation.resources.zoom_in
import com.flowyride.feature.navigation.resources.zoom_out
import com.flowyride.feature.navigation.roundedDistance
import org.jetbrains.compose.resources.getString
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import kotlin.math.roundToInt
import kotlin.time.Clock

/** Stateful entry point: permissions, one-shot messages, screen kept on. */
@Composable
fun NavigationRoute(viewModel: NavigationViewModel = koinViewModel()) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val askPermissions = rememberNavigationPermissions { granted ->
        viewModel.onAction(if (granted) NavigationAction.LocationGranted else NavigationAction.LocationDenied)
    }

    NavigationWindowEffect()
    // The map under the status bar is light: dark icons stay readable.
    StatusBarIconsEffect(darkIcons = true)
    LaunchedEffect(viewModel) {
        if (!state.simulated) askPermissions()
        viewModel.events.collect { event ->
            when (event) {
                is NavigationUiEvent.ShowMessage -> snackbarHostState.showSnackbar(
                    if (event.argument != null) getString(event.message, event.argument) else getString(event.message),
                )
            }
        }
    }

    NavigationScreen(state, viewModel::onAction, snackbarHostState, onRetryPermission = askPermissions)
}

/** Big, glanceable, nothing to type: the rider has gloves on and eyes on the road. */
@Composable
fun NavigationScreen(
    state: NavigationUiState,
    onAction: (NavigationAction) -> Unit,
    snackbarHostState: SnackbarHostState = remember { SnackbarHostState() },
    onRetryPermission: () -> Unit = {},
) {
    var confirmStop by remember { mutableStateOf(false) }
    NavigationBackHandler(rememberNavigationEventState(NavigationEventInfo.None), onBackCompleted = { confirmStop = true })

    val snapshot = state.snapshot
    BoxWithConstraints(Modifier.fillMaxSize().background(MaterialTheme.colorScheme.background)) {
        val landscape = isLandscapeLayout(maxWidth, maxHeight)
        // Map area under the panels: the rider and the overview fit in the rest.
        var obscured by remember { mutableStateOf(PaddingValues(0.dp)) }

        NavigationMap(
            track = state.track,
            doneIndex = snapshot?.trackIndex ?: 0,
            position = snapshot?.position,
            heading = snapshot?.heading,
            speedMetersPerSecond = snapshot?.speedMetersPerSecond,
            connector = snapshot?.connector,
            stops = state.stops,
            speedCameras = if (state.speedCameraAlerts) state.speedCameras else emptyList(),
            zoomOffset = state.zoomOffset,
            overview = state.overview,
            following = !state.mapMovedByHand,
            onMovedByHand = { onAction(NavigationAction.MapMoved) },
            northUpDescription = stringResource(Res.string.north_up),
            obscuredInsets = obscured,
            modifier = Modifier.fillMaxSize(),
        )

        val bar: @Composable () -> Unit = {
            BottomBar(
                snapshot = snapshot,
                overview = state.overview,
                mapMovedByHand = state.mapMovedByHand,
                onToggleOverview = { onAction(NavigationAction.ToggleOverview) },
                onRecenter = { onAction(NavigationAction.Recenter) },
                onStop = { confirmStop = true },
            )
        }
        if (landscape) {
            LandscapePanels(state, onAction, columnWidth = landscapeColumnWidth(maxWidth), bar = bar, onObscured = { obscured = it })
        } else {
            PortraitPanels(state, onAction, height = maxHeight, bar = bar, onObscured = { obscured = it })
        }

        // Centred on the free map, not on the panels.
        SnackbarHost(snackbarHostState, Modifier.padding(obscured).align(Alignment.Center))
    }

    if (confirmStop) {
        AlertDialog(
            onDismissRequest = { confirmStop = false },
            title = { Text(stringResource(Res.string.stop_confirm_title)) },
            confirmButton = {
                TextButton(onClick = {
                    confirmStop = false
                    onAction(NavigationAction.Stop)
                }) { Text(stringResource(Res.string.stop_confirm)) }
            },
            dismissButton = { TextButton(onClick = { confirmStop = false }) { Text(stringResource(Res.string.cancel)) } },
        )
    }
    state.summary?.let { summary -> ArrivedDialog(summary, onClose = { onAction(NavigationAction.Stop) }) }
    if (state.locationDenied) {
        AlertDialog(
            onDismissRequest = {},
            text = { Text(stringResource(Res.string.location_denied)) },
            confirmButton = { TextButton(onClick = onRetryPermission) { Text(stringResource(Res.string.location_retry)) } },
            dismissButton = { TextButton(onClick = { onAction(NavigationAction.Stop) }) { Text(stringResource(Res.string.stop)) } },
        )
    }
}

/** Guidance on top, speed, zoom and the bar at the bottom: the map in between. */
@Composable
private fun BoxWithConstraintsScope.PortraitPanels(
    state: NavigationUiState,
    onAction: (NavigationAction) -> Unit,
    height: Dp,
    bar: @Composable () -> Unit,
    onObscured: (PaddingValues) -> Unit,
) {
    val density = LocalDensity.current
    var topPanel by remember { mutableStateOf(0.dp) }
    var bottomPanel by remember { mutableStateOf(0.dp) }
    LaunchedEffect(topPanel, bottomPanel) { onObscured(PaddingValues(top = topPanel, bottom = bottomPanel)) }

    val safe = Modifier.windowInsetsPadding(WindowInsets.safeDrawing).padding(10.dp)
    Column(
        safe.fillMaxWidth().align(Alignment.TopCenter)
            .onGloballyPositioned { topPanel = with(density) { (it.positionInParent().y + it.size.height).toDp() } },
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        TopBanner(state, state.snapshot)
        Chips(state)
    }

    Column(
        safe.fillMaxWidth().align(Alignment.BottomCenter),
        verticalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        Row(verticalAlignment = Alignment.Bottom, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            Speed(state.snapshot)
            Spacer(Modifier.weight(1f))
            if (!state.overview && !state.mapMovedByHand) ZoomButtons(onAction)
        }
        // Only the bar hides the map: the round buttons leave the road visible around them.
        Box(Modifier.onGloballyPositioned { bottomPanel = height - with(density) { it.positionInRoot().y.toDp() } }) {
            bar()
        }
    }
}

/**
 * Phone in a landscape holder: guidance, chips and bar in a column on the left, the map on its full height on
 * the right. Speed at the foot of the column, zoom bottom right.
 */
@Composable
private fun BoxWithConstraintsScope.LandscapePanels(
    state: NavigationUiState,
    onAction: (NavigationAction) -> Unit,
    columnWidth: Dp,
    bar: @Composable () -> Unit,
    onObscured: (PaddingValues) -> Unit,
) {
    val density = LocalDensity.current
    var columnEnd by remember { mutableStateOf(0.dp) }
    LaunchedEffect(columnEnd) { onObscured(PaddingValues(start = columnEnd)) }

    Box(Modifier.matchParentSize().windowInsetsPadding(WindowInsets.safeDrawing).padding(10.dp)) {
        Column(
            Modifier.width(columnWidth).fillMaxHeight()
                .onGloballyPositioned { columnEnd = with(density) { it.boundsInRoot().right.toDp() } },
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            TopBanner(state, state.snapshot)
            Chips(state)
            Spacer(Modifier.weight(1f))
            bar()
        }
        Row(
            Modifier.align(Alignment.BottomStart).padding(start = columnWidth + 10.dp),
            verticalAlignment = Alignment.Bottom,
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            Speed(state.snapshot)
        }
        if (!state.overview && !state.mapMovedByHand) {
            Box(Modifier.align(Alignment.BottomEnd)) { ZoomButtons(onAction) }
        }
    }
}

/** Speed camera ahead (when alerts are on) and the simulation tag; they wrap when the column is narrow. */
@Composable
private fun Chips(state: NavigationUiState) {
    val ahead = state.snapshot?.cameraAhead?.takeIf { state.speedCameraAlerts }
    if (ahead == null && !state.simulated) return
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        ahead?.let {
            CameraChip(
                if (it.camera.speedLimitKmh != null) {
                    stringResource(Res.string.camera_ahead_limit, it.camera.speedLimitKmh!!, roundedDistance(it.distanceMeters))
                } else {
                    stringResource(Res.string.camera_ahead, roundedDistance(it.distanceMeters))
                },
            )
        }
        if (state.simulated) SimulationChip()
    }
}

@Composable
private fun Speed(snapshot: NavigationSnapshot?) {
    SpeedBubble(snapshot?.speedMetersPerSecond, snapshot?.speedLimitKmh)
    snapshot?.speedLimitKmh?.let { SpeedLimitSign(it) }
}

private val BannerGreen = Color(0xFF1B4332)
private val BannerBlue = Color(0xFF0D47A1)
private val BannerRed = Color(0xFF8E1B1B)

@Composable
private fun TopBanner(state: NavigationUiState, snapshot: NavigationSnapshot?) {
    val phase = snapshot?.phase
    val color = when (phase) {
        NavigationPhase.OFF_ROUTE -> BannerRed
        NavigationPhase.REJOINING, NavigationPhase.TO_START -> BannerBlue
        else -> BannerGreen
    }
    Surface(color = color, shape = RoundedCornerShape(16.dp), shadowElevation = 6.dp, modifier = Modifier.fillMaxWidth()) {
        when {
            state.preparing -> StatusLine(stringResource(Res.string.preparing_guidance), progress = true)
            snapshot == null || phase == NavigationPhase.WAITING_FOR_GPS -> StatusLine(stringResource(Res.string.waiting_gps), progress = true)
            phase == NavigationPhase.OFF_ROUTE -> OffRouteBanner(snapshot, state.connectorFailed)
            phase == NavigationPhase.ARRIVED -> ManeuverBanner(Maneuver(ManeuverType.ARRIVE, 0), null, null, phase)
            else -> ManeuverBanner(snapshot.next?.maneuver, snapshot.next?.distanceMeters, snapshot.then?.maneuver, phase)
        }
    }
}

@Composable
private fun ManeuverBanner(maneuver: Maneuver?, distance: Double?, then: Maneuver?, phase: NavigationPhase?) {
    Row(Modifier.padding(horizontal = 14.dp, vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
        ManeuverIcon(maneuver, Color.White, Modifier.size(64.dp))
        Spacer(Modifier.width(14.dp))
        Column(Modifier.weight(1f)) {
            if (distance != null) {
                Text(roundedDistance(distance), color = Color.White, fontSize = 34.sp, fontWeight = FontWeight.Bold)
            }
            val road = maneuver?.let { listOfNotNull(it.roadNumber, it.roadName).distinct().joinToString(" · ") }?.takeIf { it.isNotBlank() }
            Text(
                road ?: maneuverText(maneuver, phase),
                color = Color.White,
                fontSize = 18.sp,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
            )
            if (road != null) {
                Text(maneuverText(maneuver, phase), color = Color.White.copy(alpha = 0.8f), fontSize = 14.sp, maxLines = 1)
            }
        }
        if (then != null) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(stringResource(Res.string.then), color = Color.White.copy(alpha = 0.8f), fontSize = 13.sp)
                ManeuverIcon(then, Color.White.copy(alpha = 0.85f), Modifier.size(34.dp))
            }
        }
    }
}

@Composable
private fun OffRouteBanner(snapshot: NavigationSnapshot, connectorFailed: Boolean) {
    Row(Modifier.padding(horizontal = 14.dp, vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
        // Straight-line direction to the ride, relative to where the rider is heading.
        val relative = snapshot.bearingToRoute?.let { bearing -> bearing - (snapshot.heading ?: 0.0) } ?: 0.0
        ManeuverIcon(Maneuver(ManeuverType.STRAIGHT, 0), Color.White, Modifier.size(64.dp).rotate(relative.toFloat()))
        Spacer(Modifier.width(14.dp))
        Column(Modifier.weight(1f)) {
            Text(stringResource(Res.string.off_route), color = Color.White, fontSize = 26.sp, fontWeight = FontWeight.Bold)
            val detail = if (connectorFailed) {
                stringResource(Res.string.off_route_no_network, roundedDistance(snapshot.distanceToRouteMeters ?: 0.0))
            } else {
                stringResource(Res.string.off_route_searching)
            }
            Text(detail, color = Color.White, fontSize = 16.sp)
        }
    }
}

@Composable
private fun StatusLine(text: String, progress: Boolean) {
    Row(Modifier.padding(horizontal = 18.dp, vertical = 20.dp), verticalAlignment = Alignment.CenterVertically) {
        if (progress) {
            CircularProgressIndicator(Modifier.size(24.dp), color = Color.White, strokeWidth = 3.dp)
            Spacer(Modifier.width(14.dp))
        }
        Text(text, color = Color.White, fontSize = 20.sp)
    }
}

@Composable
private fun maneuverText(maneuver: Maneuver?, phase: NavigationPhase?): String = when (maneuver?.type) {
    null, ManeuverType.OTHER, ManeuverType.DEPART -> stringResource(Res.string.maneuver_follow_route)
    ManeuverType.STRAIGHT -> stringResource(Res.string.maneuver_straight)
    ManeuverType.TURN_LEFT -> stringResource(Res.string.maneuver_turn_left)
    ManeuverType.TURN_RIGHT -> stringResource(Res.string.maneuver_turn_right)
    ManeuverType.SHARP_LEFT -> stringResource(Res.string.maneuver_sharp_left)
    ManeuverType.SHARP_RIGHT -> stringResource(Res.string.maneuver_sharp_right)
    ManeuverType.BEAR_LEFT -> stringResource(Res.string.maneuver_bear_left)
    ManeuverType.BEAR_RIGHT -> stringResource(Res.string.maneuver_bear_right)
    ManeuverType.KEEP_LEFT -> stringResource(Res.string.maneuver_keep_left)
    ManeuverType.KEEP_RIGHT -> stringResource(Res.string.maneuver_keep_right)
    ManeuverType.EXIT_LEFT -> stringResource(Res.string.maneuver_exit_left)
    ManeuverType.EXIT_RIGHT -> stringResource(Res.string.maneuver_exit_right)
    ManeuverType.MERGE -> stringResource(Res.string.maneuver_merge)
    ManeuverType.U_TURN -> stringResource(Res.string.maneuver_u_turn)
    ManeuverType.FERRY -> stringResource(Res.string.maneuver_ferry)
    ManeuverType.WAYPOINT -> stringResource(Res.string.maneuver_waypoint)
    ManeuverType.ROUNDABOUT -> maneuver.roundaboutExit?.let { stringResource(Res.string.maneuver_roundabout_plain, it) }
        ?: stringResource(Res.string.maneuver_roundabout_any)
    // The end of a connector is not the end of the ride.
    ManeuverType.ARRIVE -> when (phase) {
        NavigationPhase.REJOINING -> stringResource(Res.string.maneuver_arrive_rejoin)
        NavigationPhase.TO_START -> stringResource(Res.string.maneuver_arrive_start)
        else -> stringResource(Res.string.maneuver_arrive)
    }
}

@Composable
private fun CameraChip(text: String) {
    Surface(color = Color(0xFFFFE3E3), shape = RoundedCornerShape(12.dp), shadowElevation = 4.dp) {
        Text(
            text,
            color = Color(0xFFC62828),
            fontWeight = FontWeight.Bold,
            fontSize = 18.sp,
            modifier = Modifier.padding(horizontal = 14.dp, vertical = 8.dp),
        )
    }
}

@Composable
private fun SimulationChip() {
    Surface(color = MaterialTheme.colorScheme.tertiaryContainer, shape = RoundedCornerShape(12.dp)) {
        Text(
            stringResource(Res.string.simulation),
            color = MaterialTheme.colorScheme.onTertiaryContainer,
            style = MaterialTheme.typography.labelLarge,
            modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp),
        )
    }
}

/** GPS speed; red when over the limit (GPS speed, a little lower than the bike's speedometer). */
@Composable
private fun SpeedBubble(speed: Double?, speedLimitKmh: Int?) {
    val kmh = speed?.let { (it * 3.6).roundToInt() }
    val over = kmh != null && speedLimitKmh != null && kmh > speedLimitKmh
    val content = if (over) MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.onSurface
    Box(
        Modifier.size(72.dp).background(MaterialTheme.colorScheme.surface, CircleShape)
            .border(2.dp, if (over) MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.outline, CircleShape),
        contentAlignment = Alignment.Center,
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(kmh?.toString() ?: "–", fontSize = 26.sp, fontWeight = FontWeight.Bold, color = content)
            Text(stringResource(Res.string.speed_unit), fontSize = 11.sp, color = MaterialTheme.colorScheme.onSurfaceVariant)
        }
    }
}

/** The road sign: white disc, red ring, whatever the theme. */
@Composable
private fun SpeedLimitSign(limitKmh: Int) {
    Box(
        Modifier.size(60.dp).background(Color.White, CircleShape).border(6.dp, Color(0xFFD32F2F), CircleShape),
        contentAlignment = Alignment.Center,
    ) {
        Text(limitKmh.toString(), fontSize = if (limitKmh >= 100) 19.sp else 22.sp, fontWeight = FontWeight.Bold, color = Color.Black)
    }
}

@Composable
private fun ZoomButtons(onAction: (NavigationAction) -> Unit) {
    Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
        RoundButton("+", stringResource(Res.string.zoom_in)) { onAction(NavigationAction.ZoomIn) }
        RoundButton("−", stringResource(Res.string.zoom_out)) { onAction(NavigationAction.ZoomOut) }
    }
}

/** 64 dp: usable with gloves. */
@Composable
private fun RoundButton(label: String, description: String, onClick: () -> Unit) {
    Surface(
        onClick = onClick,
        shape = CircleShape,
        color = MaterialTheme.colorScheme.surface,
        shadowElevation = 4.dp,
        modifier = Modifier.size(64.dp).semantics { contentDescription = description },
    ) {
        Box(contentAlignment = Alignment.Center) {
            Text(label, fontSize = 30.sp, fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.onSurface)
        }
    }
}

/**
 * Following the rider: arrival time and the overview button (or recentre, once the map was moved by hand).
 * In overview: back to the ride, or stop.
 */
@Composable
private fun BottomBar(
    snapshot: NavigationSnapshot?,
    overview: Boolean,
    mapMovedByHand: Boolean,
    onToggleOverview: () -> Unit,
    onRecenter: () -> Unit,
    onStop: () -> Unit,
) {
    Surface(color = MaterialTheme.colorScheme.surface, shape = RoundedCornerShape(16.dp), shadowElevation = 6.dp, modifier = Modifier.fillMaxWidth()) {
        Row(
            Modifier.padding(start = 18.dp, end = 10.dp, top = 10.dp, bottom = 10.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            if (overview) {
                Button(
                    onClick = onStop,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.errorContainer,
                        contentColor = MaterialTheme.colorScheme.onErrorContainer,
                    ),
                    modifier = Modifier.height(64.dp).weight(1f),
                ) {
                    Text(stringResource(Res.string.stop), fontSize = 20.sp, fontWeight = FontWeight.Bold)
                }
                Button(onClick = onToggleOverview, modifier = Modifier.height(64.dp).weight(1f)) {
                    Text(stringResource(Res.string.resume), fontSize = 20.sp, fontWeight = FontWeight.Bold)
                }
            } else {
                Column(Modifier.weight(1f)) {
                    if (snapshot != null && snapshot.phase != NavigationPhase.WAITING_FOR_GPS) {
                        val eta = Clock.System.now().toEpochMilliseconds() + (snapshot.remainingSeconds * 1_000).toLong()
                        Text(
                            stringResource(Res.string.arrival_time, formatClockTime(eta)),
                            fontSize = 24.sp,
                            fontWeight = FontWeight.Bold,
                            color = MaterialTheme.colorScheme.primary,
                        )
                        Text(
                            stringResource(Res.string.remaining, formatRemainingDuration(snapshot.remainingSeconds), roundedDistance(snapshot.remainingMeters)),
                            fontSize = 16.sp,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    } else {
                        Spacer(Modifier.height(48.dp))
                    }
                }
                if (mapMovedByHand) {
                    Button(onClick = onRecenter, modifier = Modifier.height(64.dp)) {
                        Text(stringResource(Res.string.recenter), fontSize = 20.sp, fontWeight = FontWeight.Bold)
                    }
                } else {
                    Button(
                        onClick = onToggleOverview,
                        colors = ButtonDefaults.buttonColors(
                            containerColor = MaterialTheme.colorScheme.secondaryContainer,
                            contentColor = MaterialTheme.colorScheme.onSecondaryContainer,
                        ),
                        modifier = Modifier.height(64.dp),
                    ) {
                        Text(stringResource(Res.string.overview), fontSize = 20.sp, fontWeight = FontWeight.Bold)
                    }
                }
            }
        }
    }
}

@Composable
private fun ArrivedDialog(summary: RideSummary, onClose: () -> Unit) {
    AlertDialog(
        onDismissRequest = onClose,
        title = { Text(stringResource(Res.string.arrived_title)) },
        text = {
            Text(
                stringResource(
                    Res.string.arrived_summary,
                    roundedDistance(summary.distanceMeters),
                    formatRemainingDuration(summary.durationSeconds),
                    summary.averageSpeedKmh.roundToInt(),
                ),
            )
        },
        confirmButton = { TextButton(onClick = onClose) { Text(stringResource(Res.string.arrived_close)) } },
    )
}

/** "45 min", "1 h 05". */
internal fun formatRemainingDuration(seconds: Double): String {
    val minutes = (seconds / 60).roundToInt()
    val hours = minutes / 60
    return when {
        hours == 0 -> "$minutes min"
        else -> "$hours h ${(minutes % 60).toString().padStart(2, '0')}"
    }
}
